export default __webpack_public_path__ + "static/media/campusimage.5a07d60c.jpeg";